import { useEffect, useRef, useState, memo } from "react";
import styles from "./HighlightSection.module.css";
import { HIGHLIGHT_SECTION_CONTENT } from "../../Constants";

// FontAwesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";

const HighlightSection = () => {
  const containerRef = useRef(null);
  const heroRef = useRef(null);
  const cardRef = useRef(null);

  const [isVisible, setIsVisible] = useState(false);
  const [hasClickedPlay, setHasClickedPlay] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          heroRef.current?.classList.add(styles.showHero);
          cardRef.current?.classList.add(styles.showCard);
        }
      },
      { threshold: 0.1 }
    );

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const handlePlayClick = () => {
    setHasClickedPlay(true);
  };

  return (
    <section ref={containerRef} className={styles.section}>
      {/* HERO CONTENT */}
      <div ref={heroRef} className={styles.heroContent}>
        <div className={styles.topLine}></div>
        <h1>{HIGHLIGHT_SECTION_CONTENT.heading}</h1>
        <p>{HIGHLIGHT_SECTION_CONTENT.description}</p>
      </div>

      {/* EVENT CARD */}
      <div ref={cardRef} className={styles.eventWrapper}>
        <div className={styles.imageContainer}>
          {!hasClickedPlay ? (
            <div className={styles.videoPlaceholder} onClick={handlePlayClick}>
              <div className={styles.playButton}>
                <FontAwesomeIcon icon={faPlay} />
              </div>
              <p className={styles.playText}>Watch Highlight</p>
            </div>
          ) : (
            <video
              className={styles.video}
              src="https://pub-dc5215774265416a9110e4c88aef9f9d.r2.dev/hero/featured_1774440371843.mp4"
              autoPlay
              controls
              playsInline
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default memo(HighlightSection);